<div class="row">
    <div class="col-md-6 p-0">
        <app-grid [columns]="columns" [rows]="data.tableRows" [tableParams]="data.tableParams" [multiSelect]="false"
            (refreshDataFromServer)="refreshData($event)" (rowSelected)="emitExaminerData($event)"
            [gridName]="'examExaminerGrid'" [allowAdd]="false" [allowEdit]="false" [allowView]="false"
            (deleteClicked)="removeExaminer()" [allowEdit]="false"></app-grid>
    </div>
    <div class="col-md-6 p-0">
        <app-add-examiner [selecetedExaminer]="examinationExaminer"></app-add-examiner>
    </div>
</div>